import React, { useState } from "react";

// ----- inline styles (plain CSS in JS) -----
const styles = {
    container: {
        minHeight: '100vh',
        background: '#f8fafc',
        padding: '1.5rem',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        display: 'flex',
        justifyContent: 'center',
    },
    card: {
        maxWidth: '56rem',
        width: '100%',
        background: '#ffffff',
        border: '1px solid #e5e7eb',
        borderRadius: '1.25rem',
        overflow: 'hidden',
        boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        padding: '1rem 1.5rem',
        borderBottom: '1px solid #f3f4f6',
    },
    badge: {
        width: '2.25rem',
        height: '2.25rem',
        borderRadius: '0.5rem',
        background: '#c8102e',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    badgeText: {
        color: '#fff',
        fontSize: '0.7rem',
        fontWeight: 600,
        letterSpacing: '0.04em',
    },
    headerTitle: {
        fontSize: '0.9rem',
        fontWeight: 500,
        color: '#111827',
    },
    headerSub: {
        fontSize: '0.7rem',
        color: '#9ca3af',
    },
    status: {
        marginLeft: 'auto',
        fontSize: '0.7rem',
        padding: '0.2rem 0.8rem',
        borderRadius: '999px',
        background: '#f0fdf4',
        color: '#15803d',
        border: '1px solid #bbf7d0',
    },
    body: {
        padding: '1.5rem',
    },
    sectionLabel: {
        fontSize: '0.6rem',
        textTransform: 'uppercase',
        letterSpacing: '0.12em',
        color: '#9ca3af',
        marginBottom: '0.75rem',
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '0.75rem',
        marginBottom: '1rem',
    },
    fieldGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: '0.25rem',
    },
    label: {
        fontSize: '0.7rem',
        color: '#6b7280',
    },
    input: {
        height: '2.25rem',
        padding: '0 0.75rem',
        borderRadius: '0.5rem',
        border: '1px solid #e5e7eb',
        fontSize: '0.85rem',
        color: '#1f2937',
        background: '#fff',
        outline: 'none',
        transition: 'all 0.15s',
        width: '100%',
        boxSizing: 'border-box',
    },
    select: {
        height: '2.25rem',
        padding: '0 0.75rem',
        borderRadius: '0.5rem',
        border: '1px solid #e5e7eb',
        fontSize: '0.85rem',
        color: '#1f2937',
        background: '#fff',
        outline: 'none',
        transition: 'all 0.15s',
        width: '100%',
        boxSizing: 'border-box',
    },
    colSpan: {
        gridColumn: 'span 2',
    },
    buttonRow: {
        display: 'flex',
        gap: '0.5rem',
        marginBottom: '1.25rem',
        flexWrap: 'wrap',
    },
    primaryBtn: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        height: '2.25rem',
        padding: '0 1.25rem',
        borderRadius: '0.5rem',
        background: '#c8102e',
        color: '#fff',
        fontSize: '0.85rem',
        fontWeight: 500,
        border: 'none',
        cursor: 'pointer',
        transition: 'background 0.15s, transform 0.1s',
    },
    secondaryBtn: {
        height: '2.25rem',
        padding: '0 1rem',
        borderRadius: '0.5rem',
        border: '1px solid #e5e7eb',
        background: '#fff',
        color: '#6b7280',
        fontSize: '0.85rem',
        cursor: 'pointer',
        transition: 'background 0.15s',
    },
    curlBtn: {
        marginLeft: 'auto',
        height: '2.25rem',
        padding: '0 1rem',
        borderRadius: '0.5rem',
        border: '1px solid #e5e7eb',
        background: '#fff',
        color: '#6b7280',
        fontSize: '0.85rem',
        cursor: 'pointer',
        transition: 'background 0.15s',
    },
    loadingBox: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        justifyContent: 'center',
        padding: '1.5rem 0',
    },
    spinner: {
        width: '1.25rem',
        height: '1.25rem',
        borderRadius: '999px',
        border: '2px solid #e5e7eb',
        borderTopColor: '#c8102e',
        animation: 'spin 0.8s linear infinite',
    },
    divider: {
        height: '1px',
        background: '#f3f4f6',
        marginBottom: '1rem',
    },
    summaryGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '0.75rem',
        marginBottom: '1rem',
    },
    metricCard: {
        background: '#f9fafb',
        borderRadius: '0.75rem',
        padding: '0.75rem',
    },
    metricLabel: {
        fontSize: '0.65rem',
        color: '#9ca3af',
        marginBottom: '0.25rem',
    },
    metricValue: {
        fontWeight: 500,
        fontSize: '1.25rem',
        color: '#111827',
    },
    metricValueGreen: {
        fontWeight: 500,
        fontSize: '1.25rem',
        color: '#16a34a',
    },
    metricValueSm: {
        fontWeight: 500,
        fontSize: '0.9rem',
        color: '#111827',
    },
    tableWrap: {
        border: '1px solid #f3f4f6',
        borderRadius: '0.75rem',
        overflow: 'hidden',
        marginTop: '0.5rem',
    },
    table: {
        width: '100%',
        fontSize: '0.85rem',
        borderCollapse: 'collapse',
    },
    thead: {
        background: '#f9fafb',
    },
    th: {
        padding: '0.6rem 1rem',
        textAlign: 'left',
        fontSize: '0.65rem',
        fontWeight: 500,
        color: '#9ca3af',
        letterSpacing: '0.04em',
    },
    thRight: {
        padding: '0.6rem 1rem',
        textAlign: 'right',
        fontSize: '0.65rem',
        fontWeight: 500,
        color: '#9ca3af',
        letterSpacing: '0.04em',
    },
    td: {
        padding: '0.7rem 1rem',
        borderTop: '1px solid #f3f4f6',
        fontSize: '0.8rem',
        color: '#1f2937',
    },
    tdGray: {
        padding: '0.7rem 1rem',
        borderTop: '1px solid #f3f4f6',
        fontSize: '0.7rem',
        color: '#9ca3af',
        whiteSpace: 'nowrap',
    },
    descBlock: {
        fontWeight: 500,
        color: '#1f2937',
    },
    refSmall: {
        fontSize: '0.65rem',
        color: '#9ca3af',
        marginTop: '0.1rem',
    },
    typeBadge: {
        fontSize: '0.65rem',
        padding: '0.1rem 0.6rem',
        borderRadius: '999px',
        fontWeight: 500,
        display: 'inline-block',
    },
    creditBadge: {
        background: '#f0fdf4',
        color: '#15803d',
    },
    debitBadge: {
        background: '#fef2f2',
        color: '#dc2626',
    },
    amountCredit: {
        textAlign: 'right',
        fontWeight: 500,
        color: '#16a34a',
    },
    amountDebit: {
        textAlign: 'right',
        fontWeight: 500,
        color: '#ef4444',
    },
    balanceCell: {
        textAlign: 'right',
        fontWeight: 500,
        color: '#1f2937',
    },
    footerNote: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        padding: '0.6rem 1rem',
        background: '#eff6ff',
        borderTop: '1px solid #dbeafe',
    },
    noteText: {
        fontSize: '0.7rem',
        color: '#2563eb',
    },
    toast: {
        position: 'fixed',
        bottom: '1.5rem',
        left: '50%',
        transform: 'translateX(-50%)',
        background: '#1f2937',
        color: '#fff',
        fontSize: '0.75rem',
        padding: '0.4rem 1.2rem',
        borderRadius: '999px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        zIndex: 999,
    },
    mockDataBanner: {
        padding: '0.75rem 1rem',
        background: '#fef3c7',
        border: '1px solid #f59e0b',
        borderRadius: '0.5rem',
        marginBottom: '1rem',
        color: '#92400e',
        fontSize: '0.85rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '0.5rem'
    },
    subscribeLink: {
        display: 'inline-block',
        padding: '0.3rem 1rem',
        background: '#c8102e',
        color: '#fff',
        textDecoration: 'none',
        borderRadius: '0.4rem',
        fontSize: '0.8rem',
        fontWeight: 500,
        whiteSpace: 'nowrap'
    },
    errorBox: {
        padding: '0.75rem 1rem',
        background: '#fef2f2',
        border: '1px solid #fecaca',
        borderRadius: '0.5rem',
        marginBottom: '1rem',
        color: '#dc2626',
        fontSize: '0.85rem'
    },
    successBox: {
        padding: '0.5rem 1rem',
        background: '#f0fdf4',
        borderRadius: '0.5rem',
        marginBottom: '1rem',
        fontSize: '0.85rem',
        color: '#166534'
    }
};

// ----- helper: INR formatting -----
const formatINR = (n) => {
    const num = parseFloat(n);
    if (isNaN(num)) return '0';
    return num.toLocaleString('en-IN');
};

// ----- Sub-components -----
function Field({ label, name, value, onChange, placeholder, type = 'text' }) {
    return (
        <div style={styles.fieldGroup}>
            <label style={styles.label}>{label}</label>
            <input
                type={type}
                name={name}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                style={styles.input}
            />
        </div>
    );
}

function SelectField({ label, name, value, onChange, options }) {
    return (
        <div style={styles.fieldGroup}>
            <label style={styles.label}>{label}</label>
            <select name={name} value={value} onChange={onChange} style={styles.select}>
                {options.map((o) => (
                    <option key={o.value} value={o.value}>{o.label}</option>
                ))}
            </select>
        </div>
    );
}

function MetricCard({ label, value, color, size }) {
    let valueStyle = styles.metricValue;
    if (color === 'green') valueStyle = styles.metricValueGreen;
    if (size === 'sm') valueStyle = styles.metricValueSm;
    return (
        <div style={styles.metricCard}>
            <div style={styles.metricLabel}>{label}</div>
            <div style={valueStyle}>{value}</div>
        </div>
    );
}

// ----- Main Component -----
export default function AxisBankStatement() {
    const [form, setForm] = useState({
        accountNumber: '921020006477295',
        customerId: 'CUST00123456',
        fromDate: '2024-03-01',
        toDate: '2024-06-01',
        consentToken: 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.demo_consent_token',
        txnType: 'ALL',
        format: 'JSON',
    });
    const [loading, setLoading] = useState(false);
    const [results, setResults] = useState(null);
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
        setError(null);
    };

    // fetch statement – using backend proxy
    const fetchStatement = async () => {
        setLoading(true);
        setResults(null);
        setError(null);

        try {
            const statementResponse = await fetch('http://localhost:5000/bankapi/fetch-statement', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    accountNumber: form.accountNumber,
                    startDate: form.fromDate,
                    endDate: form.toDate,
                    transactionType: form.txnType === 'ALL' ? '' : form.txnType,
                    channelId: 'WEB',
                    consentToken: form.consentToken,
                    format: form.format,
                    testId: 1
                }),
            });

            const statementData = await statementResponse.json();

            // Check if it's a subscription/plan error
            if (!statementData.status) {
                // Check for subscription error from backend
                if (statementData.errorCode === "NOT_SUBSCRIBED" || 
                    statementData.message?.includes("subscribe") || 
                    statementData.message?.includes("plan")) {
                    
                    // Show mock data with subscription banner
                    setResults({
                        accountHolder: "Demo Account (Sandbox Mode)",
                        openingBalance: 20000,
                        closingBalance: 96161,
                        transactions: [
                            { date: "2024-03-05", desc: "Salary credit", ref: "NEFT/INB2024030512345", type: "CREDIT", amount: 55000, balance: 75000 },
                            { date: "2024-03-10", desc: "Amazon Pay UPI", ref: "UPI/AMZN/240310/88123", type: "DEBIT", amount: 1499, balance: 73501 },
                            { date: "2024-03-18", desc: "HDFC EMI debit", ref: "ECS/HDFC/LOAN/0031", type: "DEBIT", amount: 12000, balance: 61501 },
                            { date: "2024-04-05", desc: "Salary credit", ref: "NEFT/INB2024040512346", type: "CREDIT", amount: 55000, balance: 116501 },
                            { date: "2024-04-22", desc: "Electricity bill", ref: "BBPS/MPEB/2404/00912", type: "DEBIT", amount: 2340, balance: 114161 },
                            { date: "2024-05-01", desc: "Rent transfer", ref: "IMPS/2405010045678", type: "DEBIT", amount: 18000, balance: 96161 },
                        ],
                        transactionCount: 6,
                        isMockData: true,
                        subscriptionRequired: true,
                        subscriptionMessage: statementData.message || 'Please subscribe to the API plan for live data'
                    });
                    
                    setToastMessage('📊 Using demo data - Please subscribe to the API plan');
                    setToast(true);
                    setTimeout(() => setToast(false), 4000);
                    
                    setLoading(false);
                    return;
                }
                
                throw new Error(statementData.message || 'Failed to fetch statement');
            }

            // Process real data
            const data = statementData.data;
            
            const transactions = (data.transactions || []).map(t => ({
                date: t.transactionDate || t.postedDate || t.valueDate || '',
                desc: t.particulars || t.transactionPraticular2 || '',
                ref: t.transactionId || t.uniqueTransactionReference || '',
                type: t.transactionType || '',
                amount: parseFloat(t.amount) || 0,
                balance: parseFloat(t.balance) || 0,
            }));

            setResults({
                accountHolder: data.accountHolder || 'Account Holder',
                openingBalance: parseFloat(data.openingBalance) || 0,
                closingBalance: parseFloat(data.closingBalance) || 0,
                transactions: transactions,
                accountNumber: data.accountNumber,
                transactionCount: data.transactionCount || data.trasactionCount || 0,
                isMockData: data.isMockData || false,
                subscriptionRequired: data.subscriptionRequired || false,
                subscriptionMessage: data.subscriptionMessage || ''
            });

            if (data.isMockData) {
                setToastMessage('⚠️ Using demo data - Subscribe for live transactions');
                setToast(true);
                setTimeout(() => setToast(false), 3000);
            } else {
                setToastMessage('✅ Data fetched successfully!');
                setToast(true);
                setTimeout(() => setToast(false), 2000);
            }

        } catch (error) {
            setError(error.message);
            console.error('API Error:', error);
        } finally {
            setLoading(false);
        }
    };

    const reset = () => {
        setResults(null);
        setError(null);
    };

    const copyCurl = () => {
        const cmd = `curl -X POST "http://localhost:5000/bankapi/fetch-statement" \\
    -H "Content-Type: application/json" \\
    -d '{"accountNumber":"${form.accountNumber}","startDate":"${form.fromDate}","endDate":"${form.toDate}","transactionType":"${form.txnType === 'ALL' ? '' : form.txnType}"}'`;
        navigator.clipboard.writeText(cmd).catch(() => { });
        setToastMessage('📋 cURL command copied!');
        setToast(true);
        setTimeout(() => setToast(false), 2000);
    };

    const filtered = results?.transactions?.filter(
        (t) => form.txnType === 'ALL' || t.type === form.txnType
    ) ?? [];

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                {/* header */}
                <div style={styles.header}>
                    <div style={styles.badge}>
                        <span style={styles.badgeText}>AXS</span>
                    </div>
                    <div>
                        <p style={styles.headerTitle}>Account statement</p>
                        <p style={styles.headerSub}>Axis Bank — fetch-account-statement v3</p>
                    </div>
                    <span style={styles.status}>✓ AA consent active</span>
                </div>

                <div style={styles.body}>
                    <p style={styles.sectionLabel}>Request parameters</p>

                    <div style={styles.grid}>
                        <Field label="Account number" name="accountNumber" value={form.accountNumber} onChange={handleChange} placeholder="XXXXXXXX1234" />
                        <Field label="Customer ID" name="customerId" value={form.customerId} onChange={handleChange} placeholder="CIF ID" />
                        <Field label="From date" name="fromDate" value={form.fromDate} onChange={handleChange} type="date" />
                        <Field label="To date" name="toDate" value={form.toDate} onChange={handleChange} type="date" />
                        <div style={styles.colSpan}>
                            <Field label="Consent token (AA framework)" name="consentToken" value={form.consentToken} onChange={handleChange} placeholder="Bearer consent token" />
                        </div>
                        <SelectField label="Transaction type" name="txnType" value={form.txnType} onChange={handleChange}
                            options={[{ value: 'ALL', label: 'All transactions' }, { value: 'CREDIT', label: 'Credit only' }, { value: 'DEBIT', label: 'Debit only' }]}
                        />
                        <SelectField label="Response format" name="format" value={form.format} onChange={handleChange}
                            options={[{ value: 'JSON', label: 'JSON' }, { value: 'XML', label: 'XML' }]}
                        />
                    </div>

                    <div style={styles.buttonRow}>
                        <button style={styles.primaryBtn} onClick={fetchStatement}>
                            ↓ Fetch statement
                        </button>
                        <button style={styles.secondaryBtn} onClick={reset}>
                            ↺ Reset
                        </button>
                        <button style={styles.curlBtn} onClick={copyCurl}>
                            ⧉ Copy cURL
                        </button>
                    </div>

                    {error && typeof error === 'string' && (
                        <div style={styles.errorBox}>
                            ⚠️ {error}
                        </div>
                    )}

                    {loading && (
                        <div style={styles.loadingBox}>
                            <div style={styles.spinner} />
                            <span style={{ fontSize: '0.85rem', color: '#9ca3af' }}>Fetching statement from Axis Bank API…</span>
                        </div>
                    )}

                    {results && (
                        <>
                            <div style={styles.divider} />
                            
                            {/* Subscription Required Banner */}
                            {results.subscriptionRequired && (
                                <div style={styles.mockDataBanner}>
                                    <span>
                                        <strong>⚠️ Demo Mode</strong> — {results.subscriptionMessage || 'Please subscribe to the API plan for live data'}
                                    </span>
                                    <a 
                                        href="https://apiportal.axis.bank.in" 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        style={styles.subscribeLink}
                                    >
                                        Subscribe Now →
                                    </a>
                                </div>
                            )}
                            
                            {/* Mock Data Indicator (without subscription error) */}
                            {results.isMockData && !results.subscriptionRequired && (
                                <div style={{ 
                                    padding: '0.5rem 1rem', 
                                    background: '#e0f2fe', 
                                    border: '1px solid #7dd3fc', 
                                    borderRadius: '0.5rem',
                                    marginBottom: '1rem',
                                    color: '#0369a1',
                                    fontSize: '0.85rem'
                                }}>
                                    ℹ️ Showing demo data. Subscribe to the API for live transactions.
                                </div>
                            )}

                            <p style={styles.sectionLabel}>Response — account summary</p>

                            <div style={styles.summaryGrid}>
                                <MetricCard label="Account holder" value={results.accountHolder} size="sm" />
                                <MetricCard label="Opening balance" value={'₹' + formatINR(results.openingBalance)} />
                                <MetricCard label="Closing balance" value={'₹' + formatINR(results.closingBalance)} color="green" />
                            </div>

                            {results.transactionCount > 0 && (
                                <div style={styles.successBox}>
                                    📊 Total transactions: {results.transactionCount}
                                </div>
                            )}

                            <p style={{ ...styles.sectionLabel, marginTop: '0.5rem' }}>Transactions</p>

                            <div style={styles.tableWrap}>
                                <table style={styles.table}>
                                    <thead style={styles.thead}>
                                        <tr>
                                            <th style={styles.th}>Date</th>
                                            <th style={styles.th}>Description</th>
                                            <th style={styles.th}>Type</th>
                                            <th style={styles.thRight}>Amount (₹)</th>
                                            <th style={styles.thRight}>Balance (₹)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filtered.length === 0 ? (
                                            <tr>
                                                <td colSpan="5" style={{ padding: '2rem 1rem', textAlign: 'center', color: '#9ca3af', fontSize: '0.85rem' }}>
                                                    No transactions to display
                                                </td>
                                            </tr>
                                        ) : (
                                            filtered.map((t, i) => (
                                                <tr key={i} style={{ borderTop: '1px solid #f3f4f6' }}>
                                                    <td style={styles.tdGray}>{t.date}</td>
                                                    <td style={styles.td}>
                                                        <div style={styles.descBlock}>{t.desc}</div>
                                                        <div style={styles.refSmall}>{t.ref}</div>
                                                    </td>
                                                    <td style={styles.td}>
                                                        <span style={{
                                                            ...styles.typeBadge,
                                                            ...(t.type === 'CREDIT' ? styles.creditBadge : styles.debitBadge)
                                                        }}>{t.type || 'N/A'}</span>
                                                    </td>
                                                    <td style={t.type === 'CREDIT' ? styles.amountCredit : styles.amountDebit}>
                                                        {t.type === 'CREDIT' ? '+' : '-'}{formatINR(t.amount)}
                                                    </td>
                                                    <td style={styles.balanceCell}>{formatINR(t.balance)}</td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                                <div style={styles.footerNote}>
                                    <span style={styles.noteText}>
                                        ℹ Showing {filtered.length} of {results.transactions?.length ?? 0} transactions · via RBI Account Aggregator framework
                                    </span>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>

            {toast && (
                <div style={{
                    ...styles.toast,
                    background: results?.isMockData ? '#92400e' : '#1f2937'
                }}>
                    {toastMessage}
                </div>
            )}

            <style>{`
                @keyframes spin { to { transform: rotate(360deg); } }
                input:focus, select:focus {
                    border-color: #c8102e;
                    box-shadow: 0 0 0 2px rgba(200,16,46,0.15);
                }
                button:hover {
                    opacity: 0.9;
                }
                .primaryBtn:hover { background: #a00d25; }
            `}</style>
        </div>
    );
}